export { SchoolAssessmentAIPreview } from "./SchoolAssessmentAIPreview"
export type { SchoolAssessmentAIPreviewProps } from "./SchoolAssessmentAIPreview"
